import React from "react";
import { useContext, createContext } from "react";

const login = () => {
  // Note: Authentication state is now managed by cookies only
  // This function is kept for backward compatibility
};

// const logout = () => {
// localStorage.removeItem("loggedIn");
// Behold the code that almost ruined my nerves:
// setTimeout(() => {
//   // localStorage.clear();
// }, 100);
// };

export type MyComponentProps = React.PropsWithChildren<{
  login: () => void;
}>;

const AuthContext = createContext<MyComponentProps>({ login });

export const AuthProvider = ({ children }: MyComponentProps) => {
  return (
    <AuthContext.Provider
      value={{
        login,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  return useContext(AuthContext);
};
